import { useReducer } from 'react';
import { colorModeReducer } from './colorModeReducer';
import { type } from './colorModeActions';
import { ColorModeContext } from './ColorModeContext';

const init = () => {
  const mode = localStorage.getItem('colorMode') || 'light';
  return {
    mode: mode,
  };
};

export const ColorModeProvider = ({ children }) => {
  const [colorModeState, dispatch] = useReducer(colorModeReducer, {}, init);

  const toggleColorMode = () => {
    const newMode = colorModeState.mode === 'light' ? 'dark' : 'light';
    localStorage.setItem('colorMode', newMode);
    dispatch({ type: type.changeMode, payload: newMode });
  };

  return (
    <ColorModeContext.Provider
      value={{
        ...colorModeState,
        toggleColorMode,
      }}
    >
      {children}
    </ColorModeContext.Provider>
  );
};
